import React, { memo, useEffect, useState } from "react";
import "./style.scss";
import { Col, List, Row, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { DEFAULT_OFFSET, ROUTER_PATH } from "../../common/constant";
import { order } from "../../services";
import InfiniteScroll from "react-infinite-scroller";
import { IOrder } from "./../../models/orderModel";
import OrderItem from "./orderItem";
import { setTitlePage } from "../../utils/helper";
import { localizeRouteKey } from "../../shared/helpers";

const ProfileOrders = memo((props: any) => {
  const { t } = useTranslation();
  const [offset, setOffset] = useState(DEFAULT_OFFSET);
  const limit = 7;
  const [orders, setOrders] = useState<IOrder[]>();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTitlePage(t("title_page_order"));

    fetchData(offset, limit, (res: any) => {
      setOrders(res.docs);
      setTotal(res.total);
      setOffset(offset + limit);
      setLoading(false);
    });
  }, []);

  const fetchData = (offset: any, limit: any, cb: any) => {
    setLoading(true);

    order.getOrders({ offset, limit }, (data, err) => {
      if (data) {
        cb(data);
      }
    });
  };

  const handleInfiniteOnLoad = () => {
    if (orders && orders.length === total) {
      setHasMore(false);
      setLoading(false);

      return;
    }

    fetchData(offset, limit, (res: any) => {
      const p = orders?.concat(res.docs);
      setOrders(p);
      setOffset(offset + limit);
      setLoading(false);
    });
  };

  return (
    <Row justify="center" align="middle" className="kd-profile-container">
      <Col span={24}>
        <Row className="kd-go-to-home">
          <a
            onClick={() =>
              props.history.push(localizeRouteKey(ROUTER_PATH.HOME))
            }>
            <img
              src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/arrow-tail.svg"
              alt=""
            />
            <span className="sub-content order-detail-bold">
              Quay lại trang chủ
            </span>
          </a>
        </Row>
        <Row justify="center" align="middle">
          <span className="main-title kd-profile-title">QUẢN LÝ ĐƠN HÀNG</span>
          {/* <span className="main-content kd-profile-go-back">
            Quay lại trang thông tin
          </span> */}
        </Row>
        {/* <Row justify="start" align="middle">
          
        </Row> */}
        <Row justify="center" align="middle">
          <Col className="kd-profile-content-wrapper">
            <Row>
              {loading && !orders ? (
                <div className="loading-container">
                  <Spin />
                </div>
              ) : (
                <InfiniteScroll
                  style={{ width: "100%" }}
                  initialLoad={false}
                  pageStart={0}
                  loadMore={handleInfiniteOnLoad}
                  hasMore={!loading && hasMore}>
                  {orders && orders.length !== 0 ? (
                    <List
                      dataSource={orders}
                      renderItem={(item) => (
                        <List.Item key={item._id}>
                          <OrderItem order={item} />
                        </List.Item>
                      )}></List>
                  ) : (
                    <div>{t("empty_order")}</div>
                  )}
                  {loading && hasMore && (
                    <div className="loading-container">
                      <Spin />
                    </div>
                  )}
                </InfiniteScroll>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
});

export default ProfileOrders;
